import React, { useContext, useState } from 'react';
import clsx from 'clsx';
import TextField from '@mui/material/TextField';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { Image, RichText, Text } from '@sitecore-jss/sitecore-jss-react';
// import { useEffect } from 'react';
// import axios from 'axios';
import Loader from '../../Loader/';
// import { OTPContext } from 'components/IBANGeneratorComponent/context';
import { OTPContext } from '../../context';

const StepThree = ({
  setError,
  initialError,
  setStep,
  recaptchaValue,
  setRecaptchaValue,
  accountNumber,
  setAccountNumber,
  title,
  description,
  inputLabel,
  inputNote,
  resultButtonText,
  resultDescription,
  resultIcon,
  resultIconTooltip,
  resultLabel,
  endPoint,
  // ibanNumber,
  // setIbanNumber,
}) => {
  const { ibanNumber, setIbanNumber } = useContext(OTPContext);
  // Component states
  const [copyClass, setCopyClass] = useState(false);
  const [loading, setLoading] = useState(false);

  // Conditional rendering
  const shouldRenderTitle = !!title?.value;
  const shouldRenderDescription = !!description?.value;
  const shouldRenderResultButtonText = !!resultButtonText?.value;
  const shouldRenderResultDescription = !!resultDescription?.value;
  const shouldRenderResultIcon = !!resultIcon?.value?.src;
  const shouldRenderResultIconTooltip = !!resultIconTooltip?.value;
  const shouldRenderResultLabel = !!resultLabel?.value;
  const accountNumberMin = 10;
  // Copy IBAN listener
  const copyUrlClick = (e) => {
    e.stopPropagation();
    if (!copyClass) {
      setCopyClass((prev) => !prev);
      setTimeout(() => {
        setCopyClass((prev) => !prev);
      }, 500);
    }
    if (navigator?.clipboard?.writeText) {
      navigator.clipboard.writeText(ibanNumber);
    }
  };

  // Generate another IBAN listener
  const generateAnotherIban = () => {
    setRecaptchaValue(null);
    setAccountNumber('');
    setIbanNumber('');
    setError(initialError);
    setStep(0);
  };
  // now iban is generated in step two in the verification method
  // useEffect(() => {
  //   (async () => {
  //     try {
  //       setLoading(true);
  //       // We call the bank api
  //       const ibanNumberResponse = await axios.get(
  //         endPoint?.value
  //           ?.replace('{accountNumber}', accountNumber)
  //           .replace('{recaptchaToken}', recaptchaValue)
  //       );
  //       setIbanNumber(ibanNumberResponse?.data);
  //     } catch (error) {
  //       console.log('Error generating IBAN', error);
  //     } finally {
  //       setLoading(false);
  //     }
  //   })();
  // }, []);

  if (accountNumber.length < accountNumberMin || recaptchaValue === null) return null;

  if (loading) {
    return (
      <div className="loader-container">
        <Loader />
      </div>
    );
  } else {
    return (
      <div className="row iban-geneartor-container">
        <div className="col-12 col-lg-5 left-side">
          {shouldRenderTitle && (
            <h3>
              <Text field={title} />
            </h3>
          )}
          {shouldRenderDescription && <RichText field={description} className="left-side-desc" />}
          <div className="input-container">
            <TextField
              InputLabelProps={{ className: 'form-element-label' }}
              disabled={true}
              className="account-input form-element"
              label={inputLabel?.value || ''}
              helperText={inputNote?.value || ''}
              value={accountNumber}
              type="tel"
              fullWidth
            />
          </div>
        </div>
        <div className={clsx('col-12 col-lg-6 right-side', 'right-side-display')}>
          {shouldRenderResultLabel && (
            <div className="result-title">
              <Text field={resultLabel} />
            </div>
          )}
          <div className="result-field">
            <div className="result-input">{ibanNumber}</div>
            <OverlayTrigger
              placement="top"
              overlay={
                <Tooltip className={clsx('custom-tooltip lightMode upward')}>
                  {shouldRenderResultIconTooltip && <Text field={resultIconTooltip} />}
                </Tooltip>
              }
            >
              <div
                onClick={copyUrlClick}
                className={clsx('copy-url', copyClass && 'copy-effect')}
                role="button"
              >
                {shouldRenderResultIcon && <Image field={resultIcon} />}
              </div>
            </OverlayTrigger>
          </div>
          {shouldRenderResultDescription && (
            <RichText className="result-note" field={resultDescription} />
          )}
          <button
            onClick={generateAnotherIban}
            className="button button-contained-secondary result-btn"
          >
            {shouldRenderResultButtonText && <Text field={resultButtonText} />}
          </button>
        </div>
      </div>
    );
  }
};

export default StepThree;
